import styled from 'styled-components';
import { InputSearch } from 'ui/inputs';
import { Menu } from 'ui/menu';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p216: pxToRem(216),
  p280: pxToRem(280),
};

export const FacetWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  padding: ${spacing.half} 0;
`;

export const LeftSection = styled.div`
  flex: 0 0 auto;
`;

export const SearchText = styled(InputSearch)`
  width: ${customSpacing.p280};
`;

export const WiderMenu = styled(Menu)`
  ul {
    width: ${customSpacing.p216};
  }
`;
